import { connect } from 'react-redux';
import React from 'react';
import PropTypes from 'prop-types';
import ContactList from './components/ContactList';
import ContactDetails from './components/ContactDetails';
import * as customer from './../../../modules/customer/profile';
import { createStructuredSelector } from 'reselect';
import { push } from 'connected-react-router';
import { BoxesRow, Box } from '../profilePage/components';
import AddContact from './components/AddContact';

const Contacts = ({ customerId, backToProfileView }) => (
    <BoxesRow>
        <Box label="Henvendelseshistorikk">
            <div className='row'>
                <div className='col-md-6'>
                    <ContactList />
                </div>
                <div className='col-md-6'>
                    <ContactDetails />
                    <AddContact />
                </div>
            </div>
        </Box>
    </BoxesRow>
);

const mapStateToProps = createStructuredSelector({
    customerId: customer.selectors.getCustomerID,
    isLoading: customer.contacts.selectors.isLoading
});

const mapDispatchToProps = (dispatch, props) => ({
    backToProfileView: customerId => dispatch(push(`/customer/${customerId}`))
});

export default connect(mapStateToProps,mapDispatchToProps)(Contacts);
